function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.399 0 0 5.399 0 12s5.399 12 12 12 12-5.399 12-12S18.596 0 12 0z",
  fill: "#E24C4B"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.748 12.002c0-5.4-4.35-9.75-9.75-9.75s-9.746 4.35-9.746 9.75 4.35 9.751 9.75 9.751 9.746-4.35 9.746-9.75z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.42 16h1.463L8.63 12.92c.76-.363 1.2-1.089 1.2-2.178 0-1.606-.947-2.442-2.476-2.442H4.966V16H6.44l-.01-2.827h.868L8.42 16zM6.418 9.587h.891c.594 0 1.067.165 1.067 1.155 0 .979-.473 1.144-1.067 1.144h-.88l-.01-2.299zM11.742 8.3l-1.111.616v1.397l1.111-.539V16h1.408V8.3h-1.408zm5.111 7.766c1.694 0 2.431-1.023 2.431-2.376 0-.968-.44-1.628-.979-1.936.297-.209.65-.748.65-1.584 0-1.056-.705-1.925-2.102-1.925-1.408 0-2.1.858-2.1 1.925 0 .836.351 1.375.637 1.584-.517.286-.968.968-.968 1.936 0 1.353.737 2.376 2.431 2.376zm0-4.73c-.594 0-.814-.418-.814-.979 0-.561.22-.968.814-.968s.814.407.814.968c0 .561-.23.979-.814.979zm0 3.487c-.78 0-1-.539-1-1.166 0-.561.186-1.243 1-1.243.803 0 1.001.682 1.001 1.243 0 .627-.22 1.166-1 1.166z",
  fill: "#3A3544"
});

function SvgR18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgR18;